import React from 'react';
import ReactMarkdown from 'react-markdown';
import { UI_TEXT, BOOKING } from '../config';

const BOOK_CALL_TOKEN = '[[BOOK_A_CALL]]';

const linkify = (text) => {
  const urlRegex = /(https?:\/\/[^\s]+)/g;
  return text.replace(urlRegex, (url) => {
    let cleanUrl = url;
    let prev;
    do {
      prev = cleanUrl;
      cleanUrl = cleanUrl.replace(/[.,;:!?]+$/, '');
      const opens = (cleanUrl.match(/\(/g) || []).length;
      const closes = (cleanUrl.match(/\)/g) || []).length;
      if (cleanUrl.endsWith(')') && closes > opens) {
        cleanUrl = cleanUrl.slice(0, -1);
      }
    } while (cleanUrl !== prev);

    const punctuation = url.slice(cleanUrl.length);
    const safeUrl = cleanUrl.replace(/[<>\\]/g, '');
    const escapedText = safeUrl.replace(/\[/g, '\\[').replace(/\]/g, '\\]');

    return `[${escapedText}](<${safeUrl}>)${punctuation}`;
  });
};

const MessageList = ({ messages, loading, messagesEndRef }) => {
  return (
    <div className="messages">
      {messages.map((msg, idx) => {
        const raw = typeof msg.content === 'string' ? msg.content : '';
        const hasBookToken = msg.role === 'assistant' && raw.includes(BOOK_CALL_TOKEN);
        const displayContent = msg.role === 'assistant'
          ? linkify(raw.replaceAll(BOOK_CALL_TOKEN, '').trim())
          : raw;

        return (
          <div key={idx} className={`message-wrapper ${msg.role}`}>
            <div className={`message-label ${msg.role}`}>
              {msg.role === 'user' ? UI_TEXT.USER_LABEL : UI_TEXT.ASSISTANT_LABEL}
            </div>
            <div className="message-content">
              <ReactMarkdown>{displayContent}</ReactMarkdown>
              {hasBookToken && (
                <a
                  className="msg-book-call-btn"
                  href={BOOKING.CAL_LINK}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Book a call with Shravanth"
                >
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                    <rect x="3" y="4" width="18" height="18" rx="2" ry="2"/>
                    <line x1="16" y1="2" x2="16" y2="6"/>
                    <line x1="8" y1="2" x2="8" y2="6"/>
                    <line x1="3" y1="10" x2="21" y2="10"/>
                  </svg>
                  Book a Call
                </a>
              )}
            </div>
          </div>
        );
      })}
      {loading && (
        <div className="message-wrapper assistant">
          <div className="message-label assistant">{UI_TEXT.ASSISTANT_LABEL}</div>
          <div className="message-content loading-dots">{UI_TEXT.LOADING_TEXT}</div>
        </div>
      )}
      <div ref={messagesEndRef} />
    </div>
  );
};

export default MessageList;
